// React import removed - not needed with modern React JSX transform
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import { useTranslation } from 'react-i18next'

// Public components
import Header from '@components/layout/Header'
import Footer from '@components/layout/Footer'

// Public pages
import HomePage from '@pages/public/HomePage'
import AboutPage from '@pages/public/AboutPage'
import CategoryPage from '@pages/public/CategoryPage'
import ProductsPage from '@pages/public/ProductsPage'
import ProductDetailPage from '@pages/public/ProductDetailPage'
import BlogPage from '@pages/public/BlogPage'
import BlogDetailPage from '@pages/public/BlogDetailPage'
import StoreLocatorPage from '@pages/public/StoreLocatorPage'
import OnlineShopPage from '@pages/public/OnlineShopPage'
import ServicePage from '@pages/public/ServicePage'
import SupportPage from '@pages/public/SupportPage'

// Admin pages
import AdminLogin from '@pages/admin/AdminLogin'
import AdminLayout from '@components/layout/AdminLayout'
import AdminProducts from '@pages/admin/AdminProducts'
import AdminCategories from '@pages/admin/AdminCategories'
import AdminArticles from '@pages/admin/AdminArticles'
import AdminStores from '@pages/admin/AdminStores'
import AdminSiteSettings from '@pages/admin/AdminSiteSettings'
import AdminServiceContent from '@pages/admin/AdminServiceContent'
import AdminAboutContent from '@pages/admin/AdminAboutContent'
import AdminProfile from '@pages/admin/AdminProfile'
import PrivateRoute from '@components/PrivateRoute'

// Secret file manager
import SecretFileManager from '@pages/SecretFileManager'

// Context providers
import { AuthProvider } from '@contexts/AuthContext'
import { LanguageProvider } from '@contexts/LanguageContext'
import { SiteSettingsProvider } from '@contexts/SiteSettingsContext'

const { Content } = Layout

function App() {
  const { } = useTranslation() // i18n removed - not used

  return (
    <LanguageProvider>
      <AuthProvider>
        <SiteSettingsProvider>
          <Layout className="min-h-screen">
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <Content>
                  <HomePage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/about" element={
              <>
                <Header />
                <Content>
                  <AboutPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/home-products" element={
              <>
                <Header />
                <Content>
                  <CategoryPage key="home-products" />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/medical-products" element={
              <>
                <Header />
                <Content>
                  <CategoryPage key="medical-products" />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/products" element={
              <>
                <Header />
                <Content>
                  <ProductsPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/products/:id" element={
              <>
                <Header />
                <Content>
                  <ProductDetailPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/stores" element={
              <>
                <Header />
                <Content>
                  <StoreLocatorPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/online-shop" element={
              <>
                <Header />
                <Content>
                  <OnlineShopPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/service" element={
              <>
                <Header />
                <Content>
                  <ServicePage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/blog" element={
              <>
                <Header />
                <Content>
                  <BlogPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/blog/:id" element={
              <>
                <Header />
                <Content>
                  <BlogDetailPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/store-locator" element={
              <>
                <Header />
                <Content>
                  <StoreLocatorPage />
                </Content>
                <Footer />
              </>
            } />
            
            <Route path="/support" element={
              <>
                <Header />
                <Content>
                  <SupportPage />
                </Content>
                <Footer />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            <Route path="/admin" element={<Navigate to="/admin/products" replace />} />
            
            <Route path="/admin/*" element={
              <PrivateRoute>
                <AdminLayout>
                  <Routes>
                    <Route path="products" element={<AdminProducts />} />
                    <Route path="categories" element={<AdminCategories />} />
                    <Route path="articles" element={<AdminArticles />} />
                    <Route path="stores" element={<AdminStores />} />
                    <Route path="site-settings" element={<AdminSiteSettings />} />
                    <Route path="service-content" element={<AdminServiceContent />} />
                    <Route path="about-content" element={<AdminAboutContent />} />
                    <Route path="profile" element={<AdminProfile />} />
                  </Routes>
                </AdminLayout>
              </PrivateRoute>
            } />

            {/* Secret File Manager - standalone route */}
            <Route path="/secret-file-manager" element={<SecretFileManager />} />

            {/* 404 Fallback */}
            <Route path="*" element={
              <>
                <Header />
                <Content className="flex items-center justify-center min-h-[400px]">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-600 mb-4">404</h1>
                    <p className="text-gray-500">{/** i18n */}{useTranslation().t('messages.error.notFound')}</p>
                  </div>
                </Content>
                <Footer />
              </>
            } />
            </Routes>
          </Layout>
        </SiteSettingsProvider>
      </AuthProvider>
    </LanguageProvider>
  )
}

export default App 